import React from 'react';
import Grid from './grid.component';
import autoBind from 'react-autobind';
import _ from 'lodash';
import { ExportTypes } from './parts/grid.factory';

const GridWithRef = React.forwardRef((props, ref) => <Grid ref={ref} {...props} />);
const fileManagerRoute = window.api_routes.smarAPD_FileManager_Domain;

class DataGrid extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);

    this.refGrid = React.createRef();
  }

  mapFilter(dataFilter) {
    return {
      filterItens: dataFilter.columns,
      filterOrder: dataFilter.order,
      pageNumber: dataFilter.pageNumber,
      pageSize: dataFilter.pageSize,
      parameters: dataFilter.parameters,
      recurso: dataFilter.recurso,
    };
  }

  async onFetchData(gridFilter) {
    const { service } = this.props.options;
    var result = { dataList: [], pageCount: 0 };
    try {
      const filter = this.mapFilter(gridFilter);
      let response = await service(filter);
      result = response.data;
    } finally {
      return result;
    }
  }

  async onPrint(gridFilter, type) {
    let header;
    switch (type) {
      case ExportTypes.XLS:
        header = 'application/vnd.ms-excel';
        break;
      case ExportTypes.PDFLandscape:
        header = 'application/pdf;orientation=landscape';
        break;
      case ExportTypes.PDFPortrait:
        header = 'application/pdf;orientation=portrait';
        break;
      case ExportTypes.TXT:
        header = 'application/octet-stream';
        break;
    }

    const { sedeService, service } = this.props.options;
    const sede = sedeService ? await sedeService() : undefined;
    const filter = {
      ...this.mapFilter(gridFilter),
      pageNumber: 1,
      pageSize: 65536, //MAX_XLS_PAGE_SIZE
      Sede: sede,
    };
    let result = await service(filter, { headers: { Accept: header, 'Access-Control-Allow-Origin': '*' } });
    var url = new URL(result.headers['content-location']);
    location.href =`${fileManagerRoute}/FileManager/${url.search}`
  }

  render() {
    this.refGrid = this.props.innerRef || this.refGrid;
    return <GridWithRef ref={this.refGrid} {...this.props} onFetchData={this.onFetchData} onPrint={this.onPrint} />;
  }
}

export default React.forwardRef((props, ref) => <DataGrid innerRef={ref} {...props} />);
